var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.8,
    height: 29.8,
    viewBox: "0 0 29.8 29.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "daylight",
    transform: "translate(0.9 0.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39282",
    "data-name": "Group 39282",
    transform: "translate(3.933 3.933)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2616",
    "data-name": "Line 2616",
    x1: 1.678,
    y1: 1.678,
    transform: "translate(18.457 18.457)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2617",
    "data-name": "Line 2617",
    x1: 1.678,
    y1: 1.678,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_2618",
    "data-name": "Line 2618",
    x1: 2.373,
    transform: "translate(25.627 14)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2619",
    "data-name": "Line 2619",
    x1: 2.373,
    transform: "translate(0 14)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2620",
    "data-name": "Line 2620",
    x1: 1.678,
    y2: 1.678,
    transform: "translate(22.389 3.933)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2621",
    "data-name": "Line 2621",
    x1: 1.678,
    y2: 1.678,
    transform: "translate(3.933 22.389)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2622",
    "data-name": "Line 2622",
    y1: 2.373,
    transform: "translate(14 25.627)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2623",
    "data-name": "Line 2623",
    y1: 2.373,
    transform: "translate(14)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2825",
    "data-name": "Ellipse 2825",
    cx: 7.119,
    cy: 7.119,
    r: 7.119,
    transform: "translate(6.881 6.881)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.6997fc93feaf58811fbda13deb64499c.svg";
export { ForwardRef as ReactComponent };